
import { Alert, Autocomplete, Box, Button, Card, CardContent, Input, Typography } from '@mui/joy'
import React, { useState } from 'react'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import Tabs from '@mui/joy/Tabs';
import TabList from '@mui/joy/TabList';
import Tab from '@mui/joy/Tab';
import TabPanel from '@mui/joy/TabPanel';
import Frageneditor from './Frageneditor';
import { post, Token } from '../../../../../Script/Session';
import PlaylistAddCheckCircleRoundedIcon from '@mui/icons-material/PlaylistAddCheckCircleRounded';
import { useNavigate } from 'react-router-dom';
import VerwantwortlichenEditor from './VerwantwortlichenEditor';
import { haspermission } from '../../../../../Script/Permission';
import Bewertungeditor from './Bewertungeditor';
import Pflichtdateieneditor from './Pflichtdateieneditor';
function SubVergleichbearbeiten({d, upd,overn}) {
    const [visible,setvisible] = useState(false);
    const [name, setname] = useState(d.name);
    const [edit,setedit] = useState(false);
    const [order, setorder] = useState(getorder());
    const [v, setv] = useState(getprev());
    const [alert, setalert] = useState(false);
    const [apriviliges, setaprivs] = useState(haspermission("19"));
    const zeiteinheit = ["Jahre", "Monate", "Wochen", "Tage"];
    const navigate = useNavigate();
    function getorder() {
        let prev = getprev();
        return prev ? prev.name : "keine";
    }
    function getprev() {
        const subkat = d.kathutil.find((a) => a.name == overn)?.subkathegories;
        if (!Array.isArray(subkat)) return;
    
        const current = subkat.find(item => item.name === d.name);
        if (!current) return;
    
        return subkat.find(item => item.order === current.order - 1);
    }
    const handleValueChange = (event, newValue) => {
        setv(newValue); // 'newValue' contains the selected option
        console.log(newValue); // log the selected option
      };
    function putname(a) {
        let body = {};
        body.token = Token.get();
        body.action = "setname";
        body.target = d.id;
        body.name = a;
        let response = post(body, "/vergleiche/sub-sparten");
        if (!response){
            return;
        }
        if (response === "OK") {
            setalert(true);
            
        }

    }
    function putoverkath(){
        let a = 0;
        if (v.name == "keine"){
            a = 0;
        }else {
            a = v.order +1 ;
        }
        let body = {};
        body.token = Token.get();
        body.action = "setoverkathegorie";
        body.target = d.id;
        body.overk = a;
        body.kathegorie = overn;
        let response = post(body, "/vergleiche/sub-sparten");
        if (!response){
            return;
        }
        if (response === "OK") {
            setalert(true);
            
        }


    }
    function formatDuration(ms) {
      const seconds = Math.floor(ms / 1000);
      const minutes = Math.floor(seconds / 60);
      const hours = Math.floor(minutes / 60);
      let days = Math.floor(hours / 24);
    
      if (days < 1) {
        return "Niemals"; // Weniger als 1 Tag → String "Niemals"
      }
    
      const years = Math.floor(days / 365);
      days -= years * 365;
    
      const months = Math.floor(days / 30);
      days -= months * 30;
    
      const weeks = Math.floor(days / 7);
      days -= weeks * 7;
    
      const parts = [];
    
      if (years > 0) parts.push(`${years} Jahr${years > 1 ? 'e' : ''}`);
      if (months > 0) parts.push(`${months} Monat${months > 1 ? 'e' : ''}`);
      if (weeks > 0) parts.push(`${weeks} Woche${weeks > 1 ? 'n' : ''}`);
      if (days > 0) parts.push(`${days} Tag${days > 1 ? 'e' : ''}`);
    
      return parts.join(', ');
    }
    const [createzeiteinheit, setcreatezeiteinheit] = useState("");
    const [createzeitanzahl, setcreatezeitanzahl] = useState(0);
    function calculate() {
        if (isnull()){
          console.log("null");
          return;
        }
        let a = 0;
        console.log(createzeitanzahl);
        if (createzeiteinheit == "Tage"){
          a = Number(createzeitanzahl);
        }else if(createzeiteinheit == "Wochen"){
          a = Number(createzeitanzahl) * 7;
        }else if(createzeiteinheit == "Monate"){
          a = Number(createzeitanzahl) * 30;
        }else if (createzeiteinheit == "Jahre"){
          a = Number(createzeitanzahl) * 365;
        }
        return a;

    }
    function isnull() {
      return [createzeiteinheit].some(value => value === null || value === "");
    }
    function dd(){
        let body = {};
        body.token = Token.get();
        body.target = d.id;
        body.targetKathegorie = overn;
        body.action = "deleteSubKathegorie";
        let response = post(body, "/vergleiche/Sparten");
        if (response == "LOGOUT"){
            navigate("/");
        }
        if (response == "OK"){
            navigate("/vergleichsKathegorien")
        }
    }
    const [index, setIndex] = React.useState(0);
    const [editupdatezeitraum,seteditupdatezeitraum] = useState(false);



    function seteditzeitraum(){
        let body = {};
        body.token = Token.get();
        body.target = d.id;
        body.targetKathegorie = overn;
        body.action = "updateupdatezeitraum";
        body.days = calculate();
        let response = post(body, "/vergleiche/sub-sparten");
        if (response == "LOGOUT"){
            navigate("/");
        }
        if (response == "OK"){
            upd();
            setalert(true);
            seteditupdatezeitraum(false);
        }


    }
  return (
    <Box sx={{bgcolor: "transparent", width: "100%", height: "100%"}}>
            <Tabs
                aria-label="Vertical tabs"
                orientation="vertical"
                sx={{ minWidth: 300, height: "100vh" }}
                value={index}
                onChange={(event, value) => {
                    if (value === 4){
                        navigate("/page-history/sub_vergleich_" + d.id)
                        return;
                    }
                    
                    setIndex(value)
                }}
                >
                <TabList>
                    <Tab>Allgemein</Tab>
                    <Tab>Fragen</Tab>
                    <Tab>Pflichtdateien</Tab>
                    <Tab>Verantwortliche</Tab>
                    <Tab>Historie</Tab>
                    <Tab sx={{color: "red"}}>Löschen</Tab>
                </TabList>
                <TabPanel value={0}>
                {alert && (
                        <Alert
                        sx={{mb: 5}}
                        variant="soft"
                        color="success"
                        startDecorator={<PlaylistAddCheckCircleRoundedIcon />}
                        endDecorator={
                            <Button size="sm" variant="solid" color="success" onClick={() => setalert(false)}>
                            Schliesen
                            </Button>
                        }
                        >
                        Ihre änderungen wurden Erfolgreich gespeichert.
                        </Alert>
                )}
                    <Card variant="soft" sx={{mb: 5}}>
                        <CardContent sx={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
                        <Box>
                            <Typography level="title-md">Name:</Typography>
                            {
                                !edit ?(
                                    <Typography>{name}</Typography>
                                ) : (
                                    <Input id='nnnnnnnnaaaaaaaaaallllllll55555' placeholder={name}/>
                                )
                            }
                            <Typography level="title-md">Übergeordnete Kathegorie:</Typography>
                            {
                                !edit? (
                                    <Typography>{order}</Typography>
                                ): (
                                    <Autocomplete 
                                    placeholder='Übergeordnete Untersparte' 
                                    options={
                                        d.kathutil
                                          ? [...d.kathutil.find((a) => a.name == overn).subkathegories.filter(item => item.name != d.name), { name: "Keine", order: 0 }]
                                          : [{ name: "Keine", order: 0 }]
                                      }
                                    getOptionLabel={(option) => option.name}
                                    onChange={
                                      handleValueChange
                                    }
                                  />
                                )
                            }
                            
                        </Box>
                            {
                                !edit ? (
                                    <Button sx={{height: "5%",mt: 1}}
                                    startDecorator={<EditOutlinedIcon/>} onClick={() => setedit(true)}>Bearbeiten</Button>
                                ) : (
                                    <Button sx={{height: "5%",mt: 1}}
                                    startDecorator={<SaveOutlinedIcon/>} onClick={() => {
                                        let n = document.getElementById("nnnnnnnnaaaaaaaaaallllllll55555").value;
                                        console.log(n);
                                        if (n && n != ""){
                                            putname(n);
                                        }
                                        console.log(v);
                                        if (v != getprev() && v != null){
                                            
                                            putoverkath()
                                        }
                                        setedit(false)
                                        upd();
                                        setname(d.name);
                                        setorder(v.name);
                                    }}>Speichern</Button>
                                )
                            }
                        </CardContent>
                    </Card>
                                        <Card variant="soft" sx={{mb: 5}}>
                        <CardContent sx={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
                        <Box>
                            <Typography level="title-md">Überprüfungszeitraum für Tarifupdates/Leistungsbeschreibungen</Typography>
                            {
                                !editupdatezeitraum ?(
                                    <Typography>{formatDuration(d.updatezeitraum)}</Typography>
                                ) : (
                                    <Box sx={{display: "flex", flexDirection: "row", mb: 1}}>
                                    <Input sx={{width: "15%"}} onChange={(event) => setcreatezeitanzahl(event.target.value)} type='number' placeholder='Anzahl' />
                                    <Autocomplete sx={{ml: 1}} options={zeiteinheit} onChange={(event,newval) => setcreatezeiteinheit(newval)}/>
                                    </Box>
                                )
                            }
                            
                        </Box>
                            {
                                !editupdatezeitraum ? (
                                    <Button sx={{height: "5%",mt: 1}}
                                    startDecorator={<EditOutlinedIcon/>} onClick={() => seteditupdatezeitraum(true)}>Bearbeiten</Button>
                                ) : (
                                    <Button sx={{height: "5%",mt: 1}}
                                    startDecorator={<SaveOutlinedIcon/>} onClick={() => {
                                        seteditzeitraum();
                                    }}>Speichern</Button>
                                )
                            }
                        </CardContent>
                    </Card>
                    <Card variant='soft'>
                        <CardContent sx={{display: "flex"}}>
                        <Typography level="title-md">Übersicht:</Typography>
                        <Typography>Fragekathegorien: {d.fragen.length}</Typography>
                        <Typography>Pflichtdateien: {Object.keys(d.pflichtdateien).length}</Typography>
                        <Typography>Verwantwortliche: {d.Verantwortliche.length}</Typography>
                        </CardContent>
                    </Card>
                </TabPanel>
                <TabPanel value={1} sx={{overflowY: "auto"}}><Frageneditor upd={upd} data={d}/></TabPanel>

                <TabPanel value={2} sx={{overflowY: "auto"}}><Pflichtdateieneditor upd={upd} data={d}/></TabPanel>
                <TabPanel value={3} sx={{overflowY: "auto"}} ><VerwantwortlichenEditor data={d} upd={upd}/></TabPanel>
                <TabPanel value={4} sx={{overflowY: "auto"}} ></TabPanel>
                <TabPanel value={5}>
                {!apriviliges ? (
                    <Typography sx={{ color: "red", p: 2 }}>
                    Löschung muss von einem Administrator vorgenommen werden.
                    </Typography>
                ) : (
                    <Box sx={{ display: 'flex', justifyContent: 'flex-start', p: 2 }}>
                    <Button sx={{bgcolor: "red"}} onClick={()=> dd()} variant="contained" color="success">
                        Löschen
                    </Button>
                    </Box>
                )}
                </TabPanel>
                </Tabs>
        



    </Box>
  )
}

export default SubVergleichbearbeiten
